import { parseQuery, Statistics } from 'eo-statistic';

import * as Cookies from 'js-cookie';
import { CONFIG } from '../config';

export enum StatisticsEvent {
  PAGE_VIEW,
}

const GoogleEventsNames = {
  [StatisticsEvent.PAGE_VIEW]: 'pageview',
};

const FacebookEventsNames = {
  [StatisticsEvent.PAGE_VIEW]: 'PageView',
};

class Service extends Statistics<StatisticsEvent> {
  public gaId = 'UA-67290580-2';
  public fpId = '839121432880062';
  public appVersion = '1.0.0';
  public gaEvents = GoogleEventsNames;
  public fbEvents = FacebookEventsNames;

  public PageViewEventName = StatisticsEvent.PAGE_VIEW;

  public mutateGaEvent(eventId: StatisticsEvent, eventCategory: string, data?: any) {
    if (typeof data === 'object') {
      data = JSON.stringify(data);
    }
    if (eventId === StatisticsEvent.PAGE_VIEW) {
      this.ga('send', eventCategory);
      return;
    }
    return {
      hitType: 'event',
      eventCategory,
      eventAction: data,
    };
  }

  public setCookie(name: string, value: any) {
    Cookies.set(name, value, CONFIG.COOKIE_CONFIG);
  }

  public getCookie(name: string): any {
    return Cookies.get(name);
  }

  public getQueryParams() {
    return parseQuery();
  }
}

export const StatisticsService = new Service();
